module.exports = __webpack_public_path__ + "img/level.8fc9e601.png";